// @ts-nocheck
import requestedDateReducer, {
    GreifCartPagesReducerRequestedDateActions,
} from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/RequestedDateReducer";
import { combineReducers } from "redux";

const cartReducers = { requestedDate: requestedDateReducer };

export type GreifPagesCartActions = GreifCartPagesReducerRequestedDateActions;
export default combineReducers(cartReducers);
